export default "__VITE_ASSET__B8xkGUbb__"